/* tslint:disable */
/* eslint-disable */
//----------------------
// <auto-generated>
//     Generated using the NSwag toolchain v13.10.6.0 (NJsonSchema v10.3.8.0 (Newtonsoft.Json v11.0.0.0)) (http://NSwag.org)
// </auto-generated>
//----------------------
// ReSharper disable InconsistentNaming

import axios, { AxiosError, AxiosInstance, AxiosRequestConfig, AxiosResponse, CancelToken } from 'axios';

export class UserAgentsClient {
    private instance: AxiosInstance;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance) {
        this.instance = instance ? instance : axios.create();
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "https://localhost:7471";
    }

    getUserAgents(userId: string | null , cancelToken?: CancelToken | undefined): Promise<ActiveAgentResponseModel[]> {
        let url_ = this.baseUrl + "/api/admin/user-agents/{userId}";
        if (userId === undefined || userId === null)
            throw new Error("The parameter 'userId' must be defined.");
        url_ = url_.replace("{userId}", encodeURIComponent("" + userId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetUserAgents(_response);
        });
    }

    protected processGetUserAgents(response: AxiosResponse): Promise<ActiveAgentResponseModel[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(ActiveAgentResponseModel.fromJS(item));
            }
            return result200;
        } else if (status === 500) {
            const _responseText = response.data;
            let result500: any = null;
            let resultData500  = _responseText;
            result500 = ErrorResponseModel.fromJS(resultData500);
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ActiveAgentResponseModel[]>(<any>null);
    }

    getUserAgentsList(  cancelToken?: CancelToken | undefined): Promise<UserAgentsResponseModel[]> {
        let url_ = this.baseUrl + "/api/admin/user-agents/list";
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetUserAgentsList(_response);
        });
    }

    protected processGetUserAgentsList(response: AxiosResponse): Promise<UserAgentsResponseModel[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(UserAgentsResponseModel.fromJS(item));
            }
            return result200;
        } else if (status === 500) {
            const _responseText = response.data;
            let result500: any = null;
            let resultData500  = _responseText;
            result500 = ErrorResponseModel.fromJS(resultData500);
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<UserAgentsResponseModel[]>(<any>null);
    }
}

export class ActiveAgentResponseModel implements IActiveAgentResponseModel {
    agentId?: number;
    displayName?: string | undefined;
    instanceNumber?: number;
    buildVersion?: string | undefined;
    currentJob?: CurrentJobModel | undefined;
    status?: StatusModel | undefined;
    lastUpdateAt?: Date;
    simulators?: SimulatorType[] | undefined;
    owner?: OwnerModel | undefined;
    isShared?: boolean;

    constructor(data?: IActiveAgentResponseModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.agentId = _data["agentId"];
            this.displayName = _data["displayName"];
            this.instanceNumber = _data["instanceNumber"];
            this.buildVersion = _data["buildVersion"];
            this.currentJob = _data["currentJob"] ? CurrentJobModel.fromJS(_data["currentJob"]) : <any>undefined;
            this.status = _data["status"] ? StatusModel.fromJS(_data["status"]) : <any>undefined;
            this.lastUpdateAt = _data["lastUpdateAt"] ? new Date(_data["lastUpdateAt"].toString()) : <any>undefined;
            if (Array.isArray(_data["simulators"])) {
                this.simulators = [] as any;
                for (let item of _data["simulators"])
                    this.simulators!.push(item);
            }
            this.owner = _data["owner"] ? OwnerModel.fromJS(_data["owner"]) : <any>undefined;
            this.isShared = _data["isShared"];
        }
    }

    static fromJS(data: any): ActiveAgentResponseModel {
        data = typeof data === 'object' ? data : {};
        let result = new ActiveAgentResponseModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["agentId"] = this.agentId;
        data["displayName"] = this.displayName;
        data["instanceNumber"] = this.instanceNumber;
        data["buildVersion"] = this.buildVersion;
        data["currentJob"] = this.currentJob ? this.currentJob.toJSON() : <any>undefined;
        data["status"] = this.status ? this.status.toJSON() : <any>undefined;
        data["lastUpdateAt"] = this.lastUpdateAt ? this.lastUpdateAt.toISOString() : <any>undefined;
        if (Array.isArray(this.simulators)) {
            data["simulators"] = [];
            for (let item of this.simulators)
                data["simulators"].push(item);
        }
        data["owner"] = this.owner ? this.owner.toJSON() : <any>undefined;
        data["isShared"] = this.isShared;
        return data; 
    }
}

export interface IActiveAgentResponseModel {
    agentId?: number;
    displayName?: string | undefined;
    instanceNumber?: number;
    buildVersion?: string | undefined;
    currentJob?: CurrentJobModel | undefined;
    status?: StatusModel | undefined;
    lastUpdateAt?: Date;
    simulators?: SimulatorType[] | undefined;
    owner?: OwnerModel | undefined;
    isShared?: boolean;
}

export class CurrentJobModel implements ICurrentJobModel {
    jobId?: number;
    jobExecutionId?: number;
    assignedAt?: Date;
    owner?: OwnerModel | undefined;

    constructor(data?: ICurrentJobModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.jobId = _data["jobId"];
            this.jobExecutionId = _data["jobExecutionId"];
            this.assignedAt = _data["assignedAt"] ? new Date(_data["assignedAt"].toString()) : <any>undefined;
            this.owner = _data["owner"] ? OwnerModel.fromJS(_data["owner"]) : <any>undefined;
        }
    }

    static fromJS(data: any): CurrentJobModel {
        data = typeof data === 'object' ? data : {};
        let result = new CurrentJobModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["jobId"] = this.jobId;
        data["jobExecutionId"] = this.jobExecutionId;
        data["assignedAt"] = this.assignedAt ? this.assignedAt.toISOString() : <any>undefined;
        data["owner"] = this.owner ? this.owner.toJSON() : <any>undefined;
        return data; 
    }
}

export interface ICurrentJobModel {
    jobId?: number;
    jobExecutionId?: number;
    assignedAt?: Date;
    owner?: OwnerModel | undefined;
}

export class OwnerModel implements IOwnerModel {
    id?: string;
    displayName?: string | undefined;
    userPrincipalName?: string | undefined;

    constructor(data?: IOwnerModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.displayName = _data["displayName"];
            this.userPrincipalName = _data["userPrincipalName"];
        }
    }

    static fromJS(data: any): OwnerModel {
        data = typeof data === 'object' ? data : {};
        let result = new OwnerModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["displayName"] = this.displayName;
        data["userPrincipalName"] = this.userPrincipalName;
        return data; 
    }
}

export interface IOwnerModel {
    id?: string;
    displayName?: string | undefined;
    userPrincipalName?: string | undefined;
}

export class StatusModel implements IStatusModel {
    isReadyForCalculation?: boolean;
    code?: string | undefined;
    title?: string | undefined;

    constructor(data?: IStatusModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.isReadyForCalculation = _data["isReadyForCalculation"];
            this.code = _data["code"];
            this.title = _data["title"];
        }
    }

    static fromJS(data: any): StatusModel {
        data = typeof data === 'object' ? data : {};
        let result = new StatusModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["isReadyForCalculation"] = this.isReadyForCalculation;
        data["code"] = this.code;
        data["title"] = this.title;
        return data; 
    }
}

export interface IStatusModel {
    isReadyForCalculation?: boolean;
    code?: string | undefined;
    title?: string | undefined;
}

export enum SimulatorType {
    Chemcad7 = 1,
    DWSIM = 2,
    Chemcad8 = 3,
}

export class ErrorResponseModel implements IErrorResponseModel {
    code?: string | undefined;
    error?: string | undefined;
    validationErrors?: { [key: string]: string[]; } | undefined;

    constructor(data?: IErrorResponseModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.code = _data["code"];
            this.error = _data["error"];
            if (_data["validationErrors"]) {
                this.validationErrors = {} as any;
                for (let key in _data["validationErrors"]) {
                    if (_data["validationErrors"].hasOwnProperty(key))
                        this.validationErrors![key] = _data["validationErrors"][key] !== undefined ? _data["validationErrors"][key] : [];
                }
            }
        }
    }

    static fromJS(data: any): ErrorResponseModel {
        data = typeof data === 'object' ? data : {};
        let result = new ErrorResponseModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["code"] = this.code;
        data["error"] = this.error;
        if (this.validationErrors) {
            data["validationErrors"] = {};
            for (let key in this.validationErrors) {
                if (this.validationErrors.hasOwnProperty(key))
                    data["validationErrors"][key] = this.validationErrors[key];
            }
        }
        return data; 
    }
}

export interface IErrorResponseModel {
    code?: string | undefined;
    error?: string | undefined;
    validationErrors?: { [key: string]: string[]; } | undefined;
}

export class UserAgentsResponseModel implements IUserAgentsResponseModel {
    userId?: string;
    user?: OwnerModel | undefined;
    uncalculatedJobs?: SimulatorCount | undefined;
    calculatingJobs?: SimulatorCount | undefined;
    availableAgents?: SimulatorCount | undefined;
    personalAgents?: SimulatorCount | undefined;

    constructor(data?: IUserAgentsResponseModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.userId = _data["userId"];
            this.user = _data["user"] ? OwnerModel.fromJS(_data["user"]) : <any>undefined;
            this.uncalculatedJobs = _data["uncalculatedJobs"] ? SimulatorCount.fromJS(_data["uncalculatedJobs"]) : <any>undefined;
            this.calculatingJobs = _data["calculatingJobs"] ? SimulatorCount.fromJS(_data["calculatingJobs"]) : <any>undefined;
            this.availableAgents = _data["availableAgents"] ? SimulatorCount.fromJS(_data["availableAgents"]) : <any>undefined;
            this.personalAgents = _data["personalAgents"] ? SimulatorCount.fromJS(_data["personalAgents"]) : <any>undefined;
        }
    }

    static fromJS(data: any): UserAgentsResponseModel {
        data = typeof data === 'object' ? data : {};
        let result = new UserAgentsResponseModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["userId"] = this.userId;
        data["user"] = this.user ? this.user.toJSON() : <any>undefined;
        data["uncalculatedJobs"] = this.uncalculatedJobs ? this.uncalculatedJobs.toJSON() : <any>undefined;
        data["calculatingJobs"] = this.calculatingJobs ? this.calculatingJobs.toJSON() : <any>undefined;
        data["availableAgents"] = this.availableAgents ? this.availableAgents.toJSON() : <any>undefined;
        data["personalAgents"] = this.personalAgents ? this.personalAgents.toJSON() : <any>undefined;
        return data; 
    }
}

export interface IUserAgentsResponseModel {
    userId?: string;
    user?: OwnerModel | undefined;
    uncalculatedJobs?: SimulatorCount | undefined;
    calculatingJobs?: SimulatorCount | undefined;
    availableAgents?: SimulatorCount | undefined;
    personalAgents?: SimulatorCount | undefined;
}

export class SimulatorCount implements ISimulatorCount {
    cC7?: number;
    cC8?: number;
    dwsim?: number;

    constructor(data?: ISimulatorCount) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.cC7 = _data["cC7"];
            this.cC8 = _data["cC8"];
            this.dwsim = _data["dwsim"];
        }
    }

    static fromJS(data: any): SimulatorCount {
        data = typeof data === 'object' ? data : {};
        let result = new SimulatorCount();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["cC7"] = this.cC7;
        data["cC8"] = this.cC8;
        data["dwsim"] = this.dwsim;
        return data; 
    }
}

export interface ISimulatorCount {
    cC7?: number;
    cC8?: number;
    dwsim?: number;
}

export class ApiException extends Error {
    message: string;
    status: number;
    response: string;
    headers: { [key: string]: any; };
    result: any;

    constructor(message: string, status: number, response: string, headers: { [key: string]: any; }, result: any) {
        super();

        this.message = message;
        this.status = status;
        this.response = response;
        this.headers = headers;
        this.result = result;
    }

    protected isApiException = true;

    static isApiException(obj: any): obj is ApiException {
        return obj.isApiException === true;
    }
}

function throwException(message: string, status: number, response: string, headers: { [key: string]: any; }, result?: any): any {
    if (result !== null && result !== undefined)
        throw result;
    else
        throw new ApiException(message, status, response, headers, null);
}

function isAxiosError(obj: any | undefined): obj is AxiosError {
    return obj && obj.isAxiosError === true;
}